import React, { useEffect, useState } from "react";

const API_BASE = import.meta.env.VITE_BACKEND_URL || "https://api.viadrive.com";
const PUBLIC_DERIV_BASE =
  import.meta.env.VITE_PUBLIC_DERIV_BASE || API_BASE.replace('/api','') + '/photos-derivatives';

export default function CuradoriaPage({ albumId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    (async ()=>{
      try{
        const token = localStorage.getItem('token');
        const r = await fetch(`${API_BASE}/api/photos/curadoria/list?album=${encodeURIComponent(albumId)}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const j = await r.json();
        // j.items = [{ jpgKey, jsonKey }]
        setItems(j.items || []);
      } finally {
        setLoading(false);
      }
    })();
  }, [albumId]);

  if (loading) return <p>Carregando…</p>;
  if (!items.length) return <p>Sem curadoria ainda.</p>;

  return (
    <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(240px,1fr))', gap:16}}>
      {items.map((it, idx)=>{
        // jpgKey: albums/.../IMG_2344/curadoria/IMG_2344.jpg
        const jpgUrl   = `${PUBLIC_DERIV_BASE}/${it.jpgKey}`;
        const jsonUrl  = `${PUBLIC_DERIV_BASE}/${it.jsonKey}`;
        const basePath = it.jpgKey.replace(/\/curadoria\/[^/]+\.jpg$/i, ""); // albums/.../IMG_2344

        const previewJpg = `${PUBLIC_DERIV_BASE}/${basePath}/preview.jpg`;
        const webWebp    = `${PUBLIC_DERIV_BASE}/${basePath}/normalized.webp`;
        const webJpg     = `${PUBLIC_DERIV_BASE}/${basePath}/normalized.jpg`;
        const highJpg    = `${PUBLIC_DERIV_BASE}/${basePath}/high/high.jpg`;
        const highTif    = `${PUBLIC_DERIV_BASE}/${basePath}/high/high.tif`;

        const label = it.jpgKey.split('/').slice(-2).join('/');

        return (
          <figure key={idx} style={card}>
            <img src={jpgUrl} alt="" style={thumb} onError={(e)=>{ e.currentTarget.style.opacity=.4; }} />
            <figcaption style={cap}>
              <div style={{fontSize:12, opacity:.75, marginBottom:6}}>{label}</div>
              <div style={links}>
                <a href={jpgUrl}    target="_blank" rel="noreferrer">Curadoria JPG</a>
                <a href={jsonUrl}   target="_blank" rel="noreferrer">JSON</a>
                <a href={previewJpg} target="_blank" rel="noreferrer">Preview</a>
                <a href={webWebp}   target="_blank" rel="noreferrer">WebP</a>
                <a href={webJpg}    target="_blank" rel="noreferrer">Web JPG</a>
                <a href={highJpg}   target="_blank" rel="noreferrer">Alta JPG</a>
                <a href={highTif}   target="_blank" rel="noreferrer">Alta TIFF</a>
              </div>
            </figcaption>
          </figure>
        );
      })}
    </div>
  );
}

const card = { margin:0, background:'#fff', borderRadius:12, overflow:'hidden', boxShadow:'0 2px 10px rgba(0,0,0,.06)' };
const thumb = { width:'100%', height:200, objectFit:'cover', display:'block', background:'#f6f6f7' };
const cap = { padding:'8px 10px 10px' };
const links = { display:'grid', gridTemplateColumns:'repeat(2, minmax(0,1fr))', gap:8, fontSize:13 };
